export default __webpack_public_path__ + "static/media/dashboard_19_covid_project-9.5768a8e3.png";